import React from "react";
import { Route, Switch, Redirect } from 'react-router-dom';
import asyncComponent from '../../../itrust_common/components/AsyncComponent';

const DashboardWrapper = asyncComponent(() =>
  import('../../../components/authorised/marketingBlast/reports/DashboardWrapper')
)

const ReportsRoutes = (
  <Switch>
    <Route exact path='/marketing-blast/analytics' component={DashboardWrapper} />
    <Redirect exact from="/marketing-blast" to="/marketing-blast/analytics" />
  </Switch>
)

export default ReportsRoutes;